import React from "react";
import styled from "styled-components";
import Globais from "../../css/Globais";

const Container = styled.div`
  width: 100%;
  height: 115%;
  position: absolute;
  top: -3rem;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  aligm-itens: center;
  @media (min-width: 1276px) {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 1rem;
    left: 0;
  }
`;

const Modal = styled.div`
  background-color: ${Globais.CorVerde};
  width: 40%;
  display: flex;

  max-width: 50rem;
  min-width: 30rem;
  min-height: 32rem;
  height: 50%;
  align-self: center;
  margin-top: -5rem;
  border-radius: 20px;

  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  box-shadow: 10px 5px 5px black;

  @media (min-width: 700px) {
    height: 50%;
  }
  @media (min-width: 1276px) {
    margin-top: 0rem;
  }
`;
const ContainerTitulo = styled.div`
  width: 50%;
  height: 20%;

  align-self: flex-start;
  margin-top: 3rem;
  align-self: center;
  @media (min-width: 1276px) {
    margin-top: 1rem;
  }
`;

const Titulo = styled.h2`
  text-align: center;
  color: #fff;
  font-size: 1.2rem;
  margin-top: -2rem;
  @media (min-width: 576px) {
    font-size: 1.2rem;
  }

  @media (min-width: 1276px) {
    font-size: 1.5rem;
    margin-top: 0rem;
  }
`;
const Close = styled.button`
  position: relative;

  right: calc(-100% + 4rem);
  align-self: flex-start;
  background-color: transparent;
  top: -2.5rem;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: bold;
  border: none;
  :hover {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  @media (min-width: 700px) {
    top: -3rem;
  }
`;

const Content = styled.div`
  width: 95%;
  height: 250%;
  margin-top: -2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-bottom: 1.2rem;
  background-color: #fff;
  box-shadow: 10px 5px 5px black;
  border-radius: 10px;
  margin-right: 0.5rem;
  @media (min-width: 500px) {
    height: 170%;
  }

  @media (min-width: 710px) {
    width: 96%;
    height: 90%;
  }
  @media (min-width: 900px) {
    width: 97%;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  @media (min-width: 1276px) {
    margin-top: -3rem;
    margin-bottom: 0.8rem;
    margin-right: 0.5rem;
  }
`;

export default function ModalMostrarPreco({
  onClose = () => {},
  children,
  id,
}: any) {
  return (
    <Container>
      <Modal>
        <ContainerTitulo>
          <Titulo>Valores</Titulo>
        </ContainerTitulo>
        <Close onClick={onClose}>X</Close>
        <Content>{children}</Content>
      </Modal>
    </Container>
  );
}
